<template>
    <div class="aba-produto">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-pacotekit-produto"
                    />
                </div>
                <div class="column" :class="[permissao.create && !integracao ? 'is-2' : 'is-3']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularColaborador"
                    >
                        {{ $t('vincular-colaborador') }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assturnocolaboradorselect"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label ? f.label : f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricaocolaborador'">
                            <a @click="selectedTurnoColaborador(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div>
                    <ColaboradorModal
                        :idColaborador="$route.params.id"
                        :selected="assTurnoColaboradorSelected"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTurnoColaboradorService from '@/services/AssTurnoColaboradorService';
import ColaboradorModal from '@/components/vendas/turno/modal/ColaboradorModal';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        ColaboradorModal,
    },
    data() {
        return {
            ProdutoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PACOTE'),
            integracao: this.$store.state.user.tabelasERPWebServer.includes('PACOTEPRODUTO'),
            assturnocolaboradorselect: [],
            fields: [
                { key: 'nomeUsuario', label: 'usuario', width: null, sortable: true, sortFn: null },
                { key: 'nomeEmpresa', label: 'empresa', sortable: true, sortFn: null },
                { key: 'situacao', sortable: true, sortFn: null },
                { key: 'excluir', sortable: false, sortFn: null },
            ],

            service: new AssTurnoColaboradorService(this.$http, this.$router),
            permissao: false,
            permissaoPacote: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            assTurnoColaboradorSelected: null,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            situacaoSelected: { id: 2, label: 'todos' },
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            abrev: this.$route.meta.contexto,
            isVenda: this.$route.meta.contexto == 'vendas',
            isDespesa: this.$route.meta.contexto == 'despesas',
            isPromotor: this.$route.meta.contexto == 'promotor',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findAllByIdTurno(
                    this.$route.params.id,
                    this.situacaoSelected.id,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assturnocolaboradorselect = value;
                    this.isEmpty = this.assturnocolaboradorselect.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.idassusuarioempresaturno,
                    nomeEmpresa: m.nomeEmpresa,
                    nomeUsuario: m.nomeUsuario,
                    situacao: m.situacao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        selectedPacoteEdit(selected) {
            this.assTurnoColaboradorSelected = selected;
            this.showModalAssociacao = true;
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['nomeUsuario'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacao() {
            let tempFailure = this.$t(
                    this.delete.situacao == 1 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('colaborador') }
                );
            let tempAssTurnoColaborador = {
                idassusuarioempresaturno: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;
            this.service
                .updateSituacao(tempAssTurnoColaborador)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('colaborador') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularColaborador() {
            this.assTurnoColaboradorSelected = null;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        selectedTurnoColaborador(selected) {
            this.assTurnoColaboradorSelected = selected;
            this.showModalAssociacao = true;
        },
        fecharModal() {
            this.assTurnoColaboradorSelected = null;
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
